const userReducer = (state = { isAdmin: false, token: null }, action) => {
  switch (action.type) {
    case "ADD_USER_AUTH":
      return action.payload;
    case "REMOVE_USER_AUTH":
      return { isAdmin: false, token: null };
    default:
      return state;
  }
};

export default userReducer;
